import React, { Component } from 'react';

import '../../global.css';
import '../yourpage/HomePage.css';

import { withRouter} from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { compose } from "recompose";

import {
   fetchStatsForGame,
   selectGame,
   fetchRecentStats,
   fetchGame,
   fetch40DaysOfGames, fetchAllPublicGames, fetchGamesCreatedByMonth
} from "../../actions";
import   withAuthorization from "../auth/withAuthorization";
import   AllHunts from "./AllHunts";
import { GameStats } from "./GameEntryListItem";
import { aggregateStatsReviewsReports } from "../huntedit/HuntActivity";
import { CREATED, PUBLIC, PUBLISHED, TITLE } from "../../constants/Game";
import { store } from "../../index";
import * as types from "../../constants/ActionTypes";
import moment from "moment";

class AdminPage extends Component {
   constructor(props) {
      super(props);

      this.state = {
         showPublic: true,
         showAll: false,
         showHuntActivity: false,
         showActivity: false,
         authorFilterText: '',
         chooseMonthText: '',
         parsedMonth: null,
         titleFilterText: '',
         selectedGame: null
      };

      this.onAuthorFilterChange = this.onAuthorFilterChange.bind(this);
      this.onChooseMonthChange = this.onChooseMonthChange.bind(this);
      this.onShowHuntsClicked = this.onShowHuntsClicked.bind(this);
      this.onShowActivityClicked = this.onShowActivityClicked.bind(this);
      this.onHuntActivitySelect = this.onHuntActivitySelect.bind(this);
      this.onShowPublicClicked = this.onShowPublicClicked.bind(this);
      this.viewSelectedGameDetails = this.viewSelectedGameDetails.bind(this);
   }

    componentDidMount() {
       fetchAllPublicGames()
    }

   onShowPublicClicked() {
      this.setState( { showPublic: true, showAll: false, showHuntActivity: false, showActivity: false });
   }

   onShowHuntsClicked() {
      fetch40DaysOfGames();
       this.setState( { showPublic: false, showAll: true, showHuntActivity: false, showActivity: false });
    }

    onShowActivityClicked() {
       fetchRecentStats();
       this.setState( { showPublic: false, showAll: false, showHuntActivity: false, showActivity: true });
    }

    onAuthorFilterChange(e) {
        this.setState({ authorFilterText: e.target.value });
    }

   // parse text.  If valid, retreive month and set more state.
   onChooseMonthChange(e) {
      const text = e.target.value;

      // set textfield state to text.
      this.setState({ chooseMonthText: text });

      // looking for text length of 7 chars to parse to date (year-month)
      if (!!text && text.length === 8) {
         const parsedDate = moment(text);
         if (! parsedDate.isValid()) {
            return;
         }

         if (parsedDate.isAfter(moment("2000"))
            && parsedDate.isBefore(moment())
            && parsedDate !== this.state.parsedMonth) {
            this.setState( { parsedMonth: parsedDate });
            fetchGamesCreatedByMonth(parsedDate)
         }
      }
      // check for valid field cleared
      else if (!!this.state.parsedMonth
               && (!text || text.length === 0) ) {
         this.setState( { parsedMonth: null });
      }
   }

   onHuntActivitySelect(game) {
       this.setState( { showPublic: false, showAll: false, showHuntActivity: true, showActivity: false });
        this.setState( { selectedGame: game })
    }

    viewSelectedGameDetails() {
        this.props.selectGame(this.state.selectedGame);
        this.props.history.push(`/games/${this.state.selectedGame.id}`);
    }

    render() {
        const { gameMap, stats, leaderboard, reviews, reports, isAdmin } = this.props;
        const { selectedGame } = this.state;

        if (!isAdmin) {
            return (
               <div> Access Error </div>
            );
        }

        let aggregatedStats = [];
        if (this.state.showHuntActivity) {
            if (!selectedGame) {
                alert("Programming error -- showHuntActivity for no selected game");
                return <div>/</div>
            }
           if (!stats
                    || stats.gameId !== selectedGame.id) {

               fetchStatsForGame(selectedGame);
                return <div>Loading...</div>
            }
            aggregatedStats = aggregateStatsReviewsReports(stats, leaderboard, reviews, reports);
        }

        if (this.state.showActivity) {
           addGameTitlesToStats(this.props.recentStats, gameMap);
        }

       const publicFilter = (game) => { return game[PUBLIC] && game[PUBLISHED] }

        // all hunts is either showing last 40 days, or chosen month
       const fortyDaysFilter = (game) => {
          if (!game[CREATED]) {
             return false
          }
          const creationDate = moment(game[CREATED].toDate())
          const fortyDays = 1000 * 3600 * 24 * 40;
          const fortyDaysAgo = moment(new Date(Date.now() - fortyDays));

          return creationDate.isAfter(fortyDaysAgo)
       }

       const monthFilter = this.state.parsedMonth == null  ?  null
           : (game) => {
              if (!game[CREATED]) {
                 return false
              }
              const creationDate = moment(game[CREATED].toDate())
              const month = this.state.parsedMonth.month();
              const year = this.state.parsedMonth.year();

              return creationDate.month()+1 === month
                   && creationDate.year() === year;
           }
        const allGamesFilter = monthFilter != null ? monthFilter : fortyDaysFilter;
        const allHuntsTitle = this.state.parsedMonth == null  ?  "last 40 days"
           : "month " + (this.state.parsedMonth.month()) +" of " + this.state.parsedMonth.year()

        return (
            <div>
                <div className="main">

                    <div className="mostly-opaque-white top-margin">

                        <h1 align="center">Admin Page</h1>

                       <div className="pull-right bottom-margin">
                       {!this.state.showAll && <div>
                          <button className="btn-link" onClick={this.onShowHuntsClicked}>
                             Show all hunts - last 40 days
                          </button>
                       </div> }
                       {!this.state.showPublic && <div>
                          <button className="btn-link" onClick={this.onShowPublicClicked}>
                             Show published public hunts
                          </button>
                       </div> }
                       {!this.state.showActivity &&
                       <div>
                       <button className="btn-link" onClick={this.onShowActivityClicked}>
                             Show Game play activity
                          </button>
                       </div> }
                       </div>

                       {this.state.showAll &&
                       <div className="big-left-margin light-text"> Choose Month (format Aug 2019)
                          <input className="left-margin" type='text' value={this.state.chooseMonthText}
                                 onChange={this.onChooseMonthChange}/>
                       </div>}

                       {this.state.showAll &&
                       <AllHunts
                          titleTimePeriod={allHuntsTitle}
                          gameFilter={allGamesFilter}
                          gameMap={gameMap}
                          authorFilterText={this.state.authorFilterText}
                          onAuthorFilterChange={this.onAuthorFilterChange}
                          onGameSelect={this.onHuntActivitySelect}
                       />
                       }

                       {this.state.showPublic &&
                       <AllHunts
                          titleTimePeriod="public"
                          gameFilter={publicFilter}
                          gameMap={gameMap}
                          authorFilterText={this.state.authorFilterText}
                          onAuthorFilterChange={this.onAuthorFilterChange}
                          onGameSelect={this.onHuntActivitySelect}
                       />
                       }

                       {this.state.showHuntActivity &&
                        <button className="btn-link bottom-margin" onClick={this.onShowHuntsClicked}> Back to hunts list </button> }

                        {this.state.showHuntActivity &&
                        <GameStats
                           game={selectedGame}
                           stats={aggregatedStats}
                           onGameDetailsSelect={this.viewSelectedGameDetails}
                           showUser={isAdmin}
                            />}

                        {this.state.showActivity && !!this.props.recentStats &&
                        <GameStats
                           title="Hunt Plays - Last 2 weeks"
                           stats={this.props.recentStats}
                           showUser={isAdmin}
                        />
                        }

                    </div>
                </div>
            </div>
        );
    }
}

function addGameTitlesToStats(stats, gameMap) {
   if (!stats || !gameMap) return;

   stats.forEach( stat => {
      if (!stat.gameId) {
         stat.gameTitle = "No game Id";
         return;
      }
      const game = gameMap[stat.gameId];
      if (!game) {
         // put dummy in there.
         store.dispatch({
            type: types.FETCH_GAME,
            payload: {id: stat.gameId, gameTitle: "Game missing"}
         });

         // try getting the real one once.
         fetchGame(stat.gameId);
         stat.gameTitle = "Game missing";
         return;
      }

      stat.gameTitle = shortenTitle(game);
   });
}

function shortenTitle(game) {

   var title = game[TITLE];
   if (!title) title = "Missing title";

   if (title.length > 28) title = title.substring(0,26) + "..";

   if (!game[PUBLIC]) title = title + " (private)";
   return title;
}

// pull in app-wide (redux) state
function mapStateToProps(state) {
    return {
        gameMap: state.games,
        isAdmin: state.sessionState.isAdmin,
        stats: state.gameStats,
        leaderboard: state.leaderboard,
        recentStats: state.recentStats,
        reviews: state.gameReviews,
        reports: state.gameReports
    };
}

// Anything returned from this function will end up as props on the HomePage container
function mapDispatchToProps(dispatch) {
    // Whenever selectGame is called, the action should be passed to all of our reducers.
    return bindActionCreators( {
        selectGame: selectGame
    }, dispatch)
}

const authCondition = (authUser) => !!authUser;

// Promote HomePage from a component to a container --
// it needs to know about this new dispatch method, selectGame.
// Make it available as a prop.
export default compose(
    withAuthorization(authCondition),
    connect(mapStateToProps, mapDispatchToProps),
    withRouter
) (AdminPage);



// WEBPACK FOOTER //
// ./src/components/yourpage/AdminPage.js